import { createWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';

interface LimitReachedStore {
  limitReached: boolean;

  handleOpenLimitReachedDialog: () => void;

  handleCloseLimitReachedDialog: () => void;
}

const useLimitReachedStore = createWithEqualityFn<LimitReachedStore>((set) => ({
  limitReached: false,

  handleOpenLimitReachedDialog() {
    set(() => ({ limitReached: true }));
  },

  handleCloseLimitReachedDialog() {
    set(() => ({ limitReached: false }));
  },
}), shallow);

export default useLimitReachedStore;
